<template>
  <div>
    <px-view-header title="Catálogos" :breadcrumbs="breadcrumbs"/>
    <px-catalogos-header :on-click-refresh="onClickRefresh"
                             :on-change-filter="onChangeFilter" />
    <px-catalogos-list :catalogos="catalogos"
                      :loading="loading"
                      :on-change-options="onChangeOptions"
                      :options-list="optionsList" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import CatalogosList from './CatalogosList.vue';
import CatalogosHeader from './CatalogosHeader.vue';
import CatalogoService from './catalogo-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresa: null,
      breadcrumbs: [
        { text: 'Catálogo' },
        { text: 'Catálogos' },
      ],
      catalogos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'nome',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCatalogos', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getCatalogos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCatalogos();
    },
    onClickRefresh() {
      this.getCatalogos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCatalogos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CatalogoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.catalogos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxCatalogosList: CatalogosList,
    pxCatalogosHeader: CatalogosHeader,
  },
};
</script>
